module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_ack_r1.htm"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_itr_r1.htm"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c01_r1.htm"
    }
  }, [_vm._v("1. Between the Reformation and a New Alliance (1566–1570)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c02_r1.htm"
    }
  }, [_vm._v("2. Dark Years (1570–1587)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c03_r1.htm"
    }
  }, [_vm._v("3. Times of Action (1587–1605)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c04_r1.htm"
    }
  }, [_vm._v("4. New Horizons (1605–1644)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c05_r1.htm"
    }
  }, [_vm._v("5. Era of Expansion (1644–1691)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c06_r1.htm"
    }
  }, [_vm._v("6. Time of Intrigue (1691–1721)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c07_r1.htm"
    }
  }, [_vm._v("7. Some Brief Reigns (1721–1775)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c08_r1.htm"
    }
  }, [_vm._v("8. The Rise and Fall of Eagles (1775–1823)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c09_r1.htm"
    }
  }, [_vm._v("9. An Era of Spies (1823–1878)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c10_r1.htm"
    }
  }, [_vm._v("10. The League of the Impious (1878–1914)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c11_r1.htm"
    }
  }, [_vm._v("11. The Horseman of the Apocalypse (1914–1917)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c12_r1.htm"
    }
  }, [_vm._v("12. Intriguing Toward Peace (1917–1922)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c13_r1.htm"
    }
  }, [_vm._v("13. Era of the Dictators (1922–1934)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c14_r1.htm"
    }
  }, [_vm._v("14. Rise of the Terror (1934–1940)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c15_r1.htm"
    }
  }, [_vm._v("15. The End of the Thousand-Year Reich (1940–1945)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c16_r1.htm"
    }
  }, [_vm._v("16. “Odessa” and the “Vatican Ratline” (1946–1958)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c17_r1.htm"
    }
  }, [_vm._v("17. New Alliances (1958–1976)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c18_r1.htm"
    }
  }, [_vm._v("18. “Vatican, Inc.” and God’s Business (1976–1978)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c19_r1.htm"
    }
  }, [_vm._v("19. Time of the Assassins (1979–1982)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_c20_r1.htm"
    }
  }, [_vm._v("20. The Polish Years (1982–2005)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_epl_r1.htm"
    }
  }, [_vm._v("Epilogue: The Years to Come: Benedict XVI")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_app_r1.htm"
    }
  }, [_c('em', [_vm._v("Appendix: List of Popes Since the Creation of the Holy Alliance")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_nts_r1.htm"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_bib_r1.htm"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_bm_r1.htm"
    }
  }, [_c('em', [_vm._v("Archives Consulted")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/9780312375942_epub_ind_r1.htm"
    }
  }, [_c('em', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-222ee19c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312375942_epub_toc_r1.vue
// module id = 69
// module chunks = 0